import script from "./ProductPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPoints.vue?vue&type=script&setup=true&lang=js"

import "./ProductPoints.vue?vue&type=style&index=0&id=c842ba72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c842ba72"]])

export default __exports__